import { Dialog, styled } from "@mui/material";

export const BaseDialog = styled(Dialog)({
  "& .MuiDialog-paper": {
    borderRadius: 16,
    width: "100%",
  },
});
